export const isRequired = value =>
  value !== null && value !== undefined && value !== ''
